// src/pages/Home.jsx
import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import GameScheduleCard from "../components/GameScheduleCard";
import toast from "react-hot-toast";
import "./Home.css";

const Home = () => {
  const { user, dashboardData, appLoading, refreshDashboardData } = useAuth();
  const [refreshing, setRefreshing] = useState(false);
  const hasFetchedInitialData = useRef(false);
const [showMaintenance, setShowMaintenance] = useState(false);
  useEffect(() => {
    // Only fetch data if:
    // 1. User is logged in
    // 2. We haven't fetched data yet (first time)
    // 3. We don't already have data
    if (user && !hasFetchedInitialData.current && !dashboardData && !appLoading) {
      console.log("Fetching initial dashboard data...");
      hasFetchedInitialData.current = true;
      handleRefresh();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, dashboardData, appLoading]);
// Check maintenance status when dashboardData loads
useEffect(() => {
  if (dashboardData?.app_maintainence_status === "1") {
    setShowMaintenance(true);
  } else {
    setShowMaintenance(false);
  }
}, [dashboardData]);
  const handleRefresh = async () => {
    // Prevent multiple simultaneous refresh calls
    if (refreshing || appLoading) {
      console.log("Refresh already in progress, skipping...");
      return;
    }

    setRefreshing(true);
    try {
      console.log("Calling refreshDashboardData API...");
      const data = await refreshDashboardData();
      if (data?.success) {
        toast.success("Dashboard updated");
        console.log("Dashboard data loaded successfully");
      }
    } catch (err) {
      toast.error("Failed to load dashboard");
      console.error("Dashboard API error:", err);
      // Reset the flag if there was an error so we can retry
      if (err.message.includes("Failed")) {
        hasFetchedInitialData.current = false;
      }
    } finally {
      setRefreshing(false);
    }
  };

  if (appLoading && !dashboardData) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="home-page">
      {/* HEADER */}
      <div className="page-header">
        <h2>Active Market</h2>
        <button
          className="refresh-btn"
          onClick={handleRefresh}
          disabled={refreshing || appLoading}
        >
          {refreshing || appLoading ? (
            <>
              <span className="spinner small"></span> Refreshing...
            </>
          ) : (
            "🔄 Refresh"
          )}
        </button>
      </div>
      {/* Homescreen Text Banner */}
{dashboardData?.homescreen_text && (
  <div className="homescreen-banner">
    <div className="homescreen-content">
      <span className="info-icon">ℹ️</span>
      <p>{dashboardData.homescreen_text}</p>
    </div>
  </div>
)}
{/* Marquee */}
{dashboardData?.marquee && (
  <div className="marquee-container">
    <marquee behavior="scroll" direction="left" scrollamount="5">
      {dashboardData.marquee}
    </marquee>
  </div>
)}
{/* Maintenance Modal */}
{/* Maintenance Modal - Full Page Overlay */}
{showMaintenance && (
  <div className="maintenance-overlay">
    <div className="maintenance-modal">
      <div className="maintenance-icon">🔧</div>
      <h3>Maintenance Mode</h3>
      <p className="maintenance-message">{dashboardData?.app_maintainence_msg || "We are currently working on this page to improve your experience."}</p>
      <p className="maintenance-submessage">Please check back later.</p>
      {dashboardData?.app_maintainence_end_time && (
        <div className="maintenance-time">
          Expected completion: {dashboardData.app_maintainence_end_time}
        </div>
      )}
    </div>
  </div>
)}
      {/* GAME GRID */}
      <div className="game-schedule-section">
        {dashboardData?.result?.length > 0 ? (
          <div className="games-grid">
            {dashboardData.result.map((game, index) => (
              <GameScheduleCard key={game._id || index} game={game} />
            ))}
          </div>
        ) : (
          <div className="no-games">
            <p>No active markets available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;